import type { ArrowDirection } from '../../components/atomic/buttons/arrows/Arrows';

export function nextPageForDirection(
  direction: ArrowDirection,
  current: number,
  maxPage: number,
): number {
  if (direction === 'up') {
    return Math.max(0, current - 1);
  }
  if (direction === 'down') {
    return Math.min(maxPage, current + 1);
  }
  return current;
}
